export default __webpack_public_path__ + "locales/ko-KR/DeleteDialog.json?hash=9bc9ead07102e6932a5c5d35e2e66d16";